import React from 'react';
import { Reveal } from './ui/Reveal';
import { benefits } from '../data/content';
export function BenefitsSection() {
  return <section aria-labelledby="cambio" className="bg-carbon" data-id="element-16" data-mp="axhve37bl2g">
      <div className="mx-auto max-w-page px-3 py-6 sm:px-6 sm:py-7" data-id="element-17" data-mp="3iqq5dleb0eu9">
        <Reveal className="text-center" data-id="element-18" data-mp="3iodozco72cjb">
          <h2 id="cambio" className="font-display text-2xl uppercase leading-none tracking-wide text-cream sm:text-4xl" data-id="element-19" data-mp="3nohuk7nkdmur">
            ¿Qué puede cambiar cuando empiezas?
          </h2>
          <p className="mt-1 text-[0.82rem] font-bold text-coral sm:text-base" data-id="element-20" data-mp="3drwork3q07pv">
            Entrenar con una estructura clara puede cambiar completamente la
            forma en la que enfrentas tus sesiones.
          </p>
        </Reveal>

        <ul className="mt-3.5 grid gap-2.5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-21" data-mp="34s9x3q0smga0">
          {benefits.map((benefit, i) => <Reveal key={benefit.title} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-xl border border-nude/30 bg-carbon-soft p-3.5" data-id="element-22" data-mp="12ysho06f8b4p" data-mpi={i}>
              <h3 className="font-display text-base uppercase leading-tight tracking-wide text-coral sm:text-lg" data-id="element-23" data-mp="27cj1wlrubt2z">
                {benefit.title}
              </h3>
              <p className="mt-1 text-[0.78rem] leading-snug text-beige sm:text-[0.82rem]" data-id="element-24" data-mp="2g5w0o4cl5owz">
                {benefit.desc}
              </p>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}